import React from 'react';

/**
 * Pagination — Common pagination component using Bootstrap 5 styling
 * 
 * Props:
 *   - currentPage: number (current page index, 1-indexed)
 *   - totalPages: number (total number of pages)
 *   - onPageChange: function (callback when a page is selected)
 */
const Pagination = ({ currentPage = 1, totalPages = 1, onPageChange }) => {
  if (totalPages <= 0) return null; // hide pagination if no pages exist

  const getPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <nav aria-label="Table navigation">
      <ul className="pagination justify-content-center mb-0">
        
        {/* Previous Button */}
        <li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Previous page"
          >
            &laquo;
          </button>
        </li>

        {/* Page Numbers */}
        {getPageNumbers().map((page) => (
          <li
            key={page}
            className={`page-item${currentPage === page ? ' active' : ''}`}
            aria-current={currentPage === page ? 'page' : undefined}
          >
            <button
              type="button"
              className="page-link"
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          </li>
        ))}

        {/* Next Button */}
        <li className={`page-item${currentPage === totalPages ? ' disabled' : ''}`}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            aria-label="Next page"
          >
            &raquo;
          </button>
        </li>

      </ul>
    </nav>
  );
};

export default Pagination;
